@if (visible) {
  <button
    #fab
    type="button"
    class="help-fab"
    [class.fab-active]="open"
    (click)="toggle()"
    matTooltip="How to use this page (F1)"
    matTooltipPosition="left"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open"
    aria-label="How to use this page"
  >
    <mat-icon>help_outline</mat-icon>
  </button>

  @if (open) {
    <div class="help-backdrop" (click)="dismiss()"></div>
    <div
      #panel
      class="help-panel"
      role="dialog"
      tabindex="-1"
      [attr.aria-label]="selected ? selected.title : title"
    >
      <div class="panel-header">
        @if (selected) {
          <button
            type="button"
            class="panel-icon-btn"
            (click)="back()"
            aria-label="Back to all workflows"
          >
            <mat-icon>arrow_back</mat-icon>
          </button>
        } @else {
          <mat-icon class="panel-title-icon">help_outline</mat-icon>
        }

        <div class="panel-heading">
          <h3 class="panel-title">{{ selected ? selected.title : title }}</h3>
          @if (!selected && subtitle) {
            <p class="panel-sub">{{ subtitle }}</p>
          }
          @if (selected && selected.summary) {
            <p class="panel-sub">{{ selected.summary }}</p>
          }
        </div>

        <button
          type="button"
          class="panel-icon-btn"
          (click)="dismiss()"
          aria-label="Close help"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="panel-body">
        @if (selected) {
          <ol class="steps">
            @for (step of selected.steps; track $index) {
              <li class="step">{{ step }}</li>
            }
          </ol>
        } @else {
          <ul class="workflows">
            @for (workflow of workflows; track workflow.id) {
              <li>
                <button type="button" class="workflow" (click)="select(workflow)">
                  <span class="workflow-text">
                    <span class="workflow-title">{{ workflow.title }}</span>
                    @if (workflow.summary) {
                      <span class="workflow-sub">{{ workflow.summary }}</span>
                    }
                  </span>
                  <mat-icon class="workflow-chevron">chevron_right</mat-icon>
                </button>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  }
}
